import _ from 'lodash';
import {XmlEntities as Entities} from 'html-entities';

const entities = new Entities();

var constants = {
  caPrivacyRightLanguages: ['en-US', 'es-LA'],
  childrensPrivacyPolicyLanguages: ['en-US', 'es-LA', 'fr-FR', 'pt-BR', 'nl-NL'],
  postalLanguages: ['en-US', 'es-ES', 'fr-FR']
};

// The childrens privacy policy and california privacy policy pages in privacy center are only in en-US and es-LA
// so set the language for those links separately
var currLangPref = 'en-US';
var caliLangPref = 'en-US';
var childrensLangPref = 'en-US';
var postalLangPref = 'en-US';
if (!_.isUndefined(window.langPref)) {
  currLangPref = window.langPref;
  if (_.includes(constants.postalLanguages, currLangPref)){
    if (currLangPref === 'es-LA') {
      postalLangPref = 'es-ES';
    } else {
      postalLangPref = currLangPref;
    }
  }
  if (_.includes(constants.caPrivacyRightLanguages, currLangPref)){
    caliLangPref = currLangPref;
  }
  if (_.includes(constants.childrensPrivacyPolicyLanguages, currLangPref)){
    childrensLangPref = currLangPref;
  }
}

let guestId = encodeURIComponent(entities.decode(window.guestId));
let host = window.location.host;

if ((window.env && window.env.toUpperCase() === 'PROD') || (window.env && window.env.toUpperCase() === 'PROD-DARK')) {
  constants.permissionCenterClientId = 'DTSS-PERMISSIONCENTER.WEB-PROD';
} else {
  constants.permissionCenterClientId = 'DTSS-PERMISSIONCENTER.WEB-STAGE';
}

let search = window.location.search;
if (search) {
  constants.managePageHref = `https://${host}/manage/${guestId}/${currLangPref}${search}`;
  constants.loginPageHref = `https://${host}/${currLangPref}${search}`;
} else {
  constants.managePageHref = `https://${host}/manage/${guestId}/${currLangPref}`;
  constants.loginPageHref = `https://${host}/${currLangPref}`;
}

constants = {
  ...constants,

  urlParamClientId: 'CLIENTID=',
  login: 'LOGIN=',
  urlParamLangPref: 'LANGPREF=',
  urlParamEmail: 'EE=',
  urlParamPermission: 'PE=',

  postalAvailableLanguages: [
    { code: 'en-US', name: 'English (US)' },
    { code: 'es-ES', name: 'Spanish (Spain)' },
    { code: 'fr-FR', name: 'French (France)' },
  ],

  // Languages
   availableLanguages: [
    { code: 'ar-AR', name: 'Arabic' },
    { code: 'bg-BG', name: 'Bulgarian' },
    { code: 'cs-CZ', name: 'Czech' },
    { code: 'da-DK', name: 'Danish' },
    { code: 'de-DE', name: 'German' },
    { code: 'el-GR', name: 'Greek' },
    { code: 'en-AU', name: 'English (Australia)' },
    { code: 'en-UK', name: 'English (UK)' },
    { code: 'en-US', name: 'English (US)' },
    { code: 'es-ES', name: 'Spanish (Spain)' },
    { code: 'es-LA', name: 'Spanish (Latin America)' },
    { code: 'fi-FI', name: 'Finnish' },
    { code: 'fr-CA', name: 'French (Canada)' },
    { code: 'fr-FR', name: 'French (France)' },
    { code: 'he-IL', name: 'Hebrew' },
    { code: 'hi-IN', name: 'Hindi' },
    { code: 'hu-HU', name: 'Hungarian' },
    { code: 'id-ID', name: 'Indonesian' },
    { code: 'it-IT', name: 'Italian' },
    { code: 'ja-JP', name: 'Japanese' },
    { code: 'ko-KR', name: 'Korean' },
    { code: 'ms-MY', name: 'Malay' },
    { code: 'nb-NO', name: 'Norwegian (Bokmal)' },
    { code: 'nl-BE', name: 'Dutch (Belgium)' },
    { code: 'nl-NL', name: 'Dutch' },
    { code: 'pl-PL', name: 'Polish' },
    { code: 'pt-BR', name: 'Portuguese (Brazil)' },
    { code: 'pt-PT', name: 'Portuguese (Portugal)' },
    { code: 'ro-RO', name: 'Romanian' },
    { code: 'ru-RU', name: 'Russian' },
    { code: 'sr-RS', name: 'Serbian (Serbia - Cyrillic)' },
    { code: 'sv-SE', name: 'Swedish (Sweden)' },
    { code: 'sk-SK', name: 'Slovak' },
    { code: 'tl-PH', name: 'Filipino' },
    { code: 'th-TH', name: 'Thai' },
    { code: 'tr-TR', name: 'Turkish'},
    { code: 'vi-VN', name: 'Vietnamese' },
    { code: 'zh-CN', name: 'Chinese Simplified (China)' },
    { code: 'zh-HK', name: 'Chinese Traditional (Hong Kong)' },
    { code: 'zh-TW', name: 'Chinese Traditional (Taiwan)' },
  ],
  defaultLangCode: 'en-US',

  // "Page" Names
  unsubscribePageName: 'unsubscribe',
  subscribePageName: 'subscribe',
  managePageName: 'manage',
  anonymousPageName: 'login',
  postalPageName: 'postal',
  confirmPageName: 'confirm',

  // Permission Type Codes
  categoryPermissionType: 'cat',
  itemPermissionType: 'item',
  FOBPermissionType: 'F',
  LOBPermissionType: 'L',
  NLPermissionType: 'N',
  thirdPartyPermissionType: 'T',

  // Disabled / Enabled State Codes
  disabledStateCode: 'D',
  enabledStateCode: 'E',
  suppressedStateCode: 'S',
  pendingStateCode: 'P',

  // Permission Attributes
  permissionStatementKey: 'statement',
  permissionStatementTextKey: 'text',
  permissionStateKey: 'state',
  permissionChildrenKey: 'children',

  // NULL Value Display Strings
  permissionFriendlyNameMissing: 'NO NAME',
  permissionStatementMissing: 'NO STATEMENT',

  // API 200 Error Code Received
  errorCodeKey: 'errorCode',
  messageKey: 'message',

  // Error Codes
  expiredClickback: 'EXPIRED_CLICKBACK',

  // Analytics Save Types
  unsubAllSaveType: 'unsubAll',
  subOneSaveType: 'subOne',
  suppressionSaveType: 'unsubAll',
  mixedSaveType: 'mixed',
  enableSomeSaveType: 'enableSome',
  unsubSomeSaveType: 'unsubSome',
  successSaveOutcome: 'success',
  subOneSaveTypeSuccess: 'subOneSuccess',
  fakeSaveType: 'fake',

  //Analytics login types
  'loginTypes': {
    'lightbox': 'lightbox',
    'clickback': 'clickback',
    'sessionTransfer': 'sessionTransfer',
    'encryptedEmail': 'encryptedEmail',
    'na': 'n/a'
  },

  // Repeated hrefs
  privacyPolicyHref: `https://privacy.thewaltdisneycompany.com/redirect/${currLangPref}/`,
  currentPrivacyPolicyHref: `https://privacy.thewaltdisneycompany.com/redirect/${currLangPref}/current-privacy-policy/`,
  interestBasedAdsHref: 'https://privacy.thewaltdisneycompany.com/en/privacy-controls/online-tracking-and-advertising/',
  childrensPrivacyPolicyHref: `https://privacy.thewaltdisneycompany.com/redirect/${childrensLangPref}/for-parents/childrens-online-privacy-policy/`,
  californiaPrivacyRightsHref: `https://privacy.thewaltdisneycompany.com/redirect/${caliLangPref}/current-privacy-policy/your-california-privacy-rights/`,
  usStatePrivacyRightsHref: 'https://privacy.thewaltdisneycompany.com/en/current-privacy-policy/your-us-state-privacy-rights/',
  doNotSellMyInfoHref: `https://privacy.thewaltdisneycompany.com/${currLangPref}/dnsmi/`,
  doNotSellOrShareMyInfoHref: 'https://privacy.thewaltdisneycompany.com/en/dnssmpi/',
  customerServiceHref: `https://privacy.thewaltdisneycompany.com/redirect/${currLangPref}/support/`,
  manageMoreHref: `https://privacy.thewaltdisneycompany.com/redirect/${currLangPref}/privacy-controls/communication-choices/`,
  termsOfUseHref: 'https://disneytermsofuse.com/',
  ourBusinessesHref: 'https://thewaltdisneycompany.com/about/#our-businesses',
  postalHref: `${window.location.origin}/postalOptout/${postalLangPref}`,
  fobHref: `https://privacy.thewaltdisneycompany.com/en/definitions/#The-Walt-Disney-Family-of-Companies`,

  availableStates: {
    'AL': 'Alabama',
    'AK': 'Alaska',
    'AS': 'American Samoa',
    'AZ': 'Arizona',
    'AR': 'Arkansas',
    'AA': 'Armed Forces Americas (except Canada)',
    'AE': 'Armed Forces Europe, the Middle East, and Canada',
    'AP': 'Armed Forces Pacific',
    'CA': 'California',
    'CO': 'Colorado',
    'CT': 'Connecticut',
    'DE': 'Delaware',
    'DC': 'District of Columbia',
    'FL': 'Florida',
    'GA': 'Georgia',
    'GU': 'Guam',
    'HI': 'Hawaii',
    'ID': 'Idaho',
    'IL': 'Illinois',
    'IN': 'Indiana',
    'IA': 'Iowa',
    'KS': 'Kansas',
    'KY': 'Kentucky',
    'LA': 'Louisiana',
    'ME': 'Maine',
    'MD': 'Maryland',
    'MA': 'Massachusetts',
    'MI': 'Michigan',
    'MN': 'Minnesota',
    'MS': 'Mississippi',
    'MO': 'Missouri',
    'MT': 'Montana',
    'NE': 'Nebraska',
    'NV': 'Nevada',
    'NH': 'New Hampshire',
    'NJ': 'New Jersey',
    'NM': 'New Mexico',
    'NY': 'New York',
    'NC': 'North Carolina',
    'ND': 'North Dakota',
    'MP': 'Northern Mariana Islands',
    'OH': 'Ohio',
    'OK': 'Oklahoma',
    'OR': 'Oregon',
    'PA': 'Pennsylvania',
    'PR': 'Puerto Rico',
    'RI': 'Rhode Island',
    'SC': 'South Carolina',
    'SD': 'South Dakota',
    'TN': 'Tennessee',
    'TX': 'Texas',
    'VI': 'US Virgin Islands',
    'UT': 'Utah',
    'VT': 'Vermont',
    'VA': 'Virginia',
    'WA': 'Washington',
    'WV': 'West Virginia',
    'WI': 'Wisconsin',
    'WY': 'Wyoming',
  },

  availableProvinces: {
    'AB': 'Alberta',
    'BC': 'British Columbia',
    'MB': 'Manitoba',
    'NB': 'New Brunswick',
    'NL': 'Newfoundland and Labrador',
    'NS': 'Nova Scotia',
    'NT': 'Northwest Territories',
    'NU': 'Nunavut',
    'ON': 'Ontario',
    'PE': 'Prince Edward Island',
    'QC': 'Quebec',
    'SK': 'Saskatchewan',
    'YT': 'Yukon'
  },

  availableCountries: {
    'US': 'United States',
    'CA': 'Canada'
  },

  telemetry: {
    actions: {
      componentDidMount: "componentDidMount",
      didOnLogin: "componentDidOnLogin",
      didOnLogout:'didOnLogout',
      didOnUpdate:'didOnUpdate',
      didOnClose: "didOnClose",
      didOnError: "didOnError",
      didInitialized: "didInitialized",
      translationsFetched: "translationsFetched",
    },
  }

};

export {
  constants
};



// WEBPACK FOOTER //
// ./client/src/utils/constants.js